<template>
    <rkm-table
        :fields="fields.datatables.item"
        :items="itens"
        ref="Table"
        hide-filters
    >
        <template v-slot:cell(exame.procedimento)="{ item }">
            {{ formatProcedimento(item.exame.codigo) }} - {{ item.exame.procedimentoNome }}
        </template>

        <template v-slot:cell(actions)="{ index }">
            <rkm-button
                color="danger"
                title="Excluir"
                small
                @click.stop="handleDestroy(index)"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
import { formats } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    item: [
                        { key: 'exame.nome', label: 'Nome', sortable: true },
                        { key: 'exame.procedimento', label: 'Procedimento', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' }
                    ],
                },
            }
        },
    },
    mixins: [formats],
    methods: {
        handleDestroy(index) {

            const destroy = async () => this.itens.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o exame?', destroy)
        },
    },
    props: {
        itens: { type: Array, default: () => [] }
    },
}
</script>